/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import "react-datepicker/dist/react-datepicker.css";

import { ChangeToDateFormat } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const SalesNoteDetail = ({
  varDeliveryIndex,
  varDeliveryLists,
  varShowDeliveryDetail,
  setShowDeliveryDetail,
  memberId,
  deliveryName,
}) => {
  const [isNew, setIsNew] = useState(false);
  const [noteData, setNoteData] = useState("");
  const [date, setDate] = useState();

  const getNoteInformation = async (selectedDate) => {
    const sendData = { mem_idx: memberId, settlement_month: selectedDate };
    await axios
      .post(`${process.env.REACT_APP_HOST}/_get_settlement_note`, sendData)
      .then((res) => {
        const datas = res.data;
        if (datas.retvalue === 1) {
          setIsNew(false);
          setNoteData(datas.settlement_note);
        } else {
          setIsNew(true);
          setNoteData("");
        }
      });
  };

  const addNoteInformation = async () => {
    const sendData = {
      mem_idx: memberId,
      settlement_month: date,
      settlement_note: noteData,
    };
    await axios
      .post(`${process.env.REACT_APP_HOST}/_insert_settlement_note`, sendData)
      .then((res) => {
        const datas = res.data;
        if (datas.retvalue === 1) {
          alert("메모가 등록되었습니다");
        } else {
          alert("잠시 후 다시 시도해주세요");
        }
        setShowDeliveryDetail(false);
      });
  };

  const updateNoteInformation = async () => {
    const sendData = {
      mem_idx: memberId,
      settlement_month: date,
      settlement_note: noteData,
    };
    await axios
      .post(`${process.env.REACT_APP_HOST}/_update_settlement_note`, sendData)
      .then((res) => {
        const datas = res.data;
        if (datas.retvalue === 1) {
          alert("메모가 수정되었습니다");
        } else {
          alert("잠시 후 다시 시도해주세요");
        }
        setShowDeliveryDetail(false);
      });
  };

  useEffect(() => {
    if (memberId > 0) {
      getNoteInformation(date);
    }
  }, [memberId, date, varShowDeliveryDetail]);

  const formatDateToFirstOfMonth = (sdate) => {
    let year = sdate?.getFullYear();
    let month = ("0" + (sdate?.getMonth() + 1)).slice(-2);
    return `${year}-${month}-01`;
  };

  useEffect(() => {
    const initialDate = formatDateToFirstOfMonth(new Date());
    setDate(initialDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varShowDeliveryDetail]);

  const onChangeDateHandler = (date) => {
    const formattedDate = formatDateToFirstOfMonth(date);
    setDate(formattedDate);
  };

  const onChangeNoteHandler = (e) => {
    setNoteData(e.target.value);
  };

  return (
    <div className={varShowDeliveryDetail ? "note__pop open" : "note__pop"}>
      <div className="note__pop__title">
        <div className="title">정산메모</div>
      </div>

      <div id="delivery_detail" className="admin-content">
        <h2 style={{ margin: "20px 0px 10px 0px", fontSize: "18px" }}>
          {deliveryName} 기사님
        </h2>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="write">
            <td style={{ padding: 0 }}>
              <input
                readOnly
                type="text"
                value={date}
                style={{ width: "140px" }}
              />
              <DatePicker
                locale={ko}
                className="datepicker"
                selectsStart
                dateFormat="yyyy-MM"
                showMonthYearPicker
                selected={ChangeToDateFormat(date)}
                onChange={onChangeDateHandler}
              />
            </td>
          </div>
          <textarea
            name="dc_prd_notice"
            style={{ height: "120px" }}
            value={noteData}
            onChange={onChangeNoteHandler}
          />
        </div>

        <div className="btn-center">
          <button
            className="btn line black"
            onClick={() => setShowDeliveryDetail(false)}
          >
            닫기
          </button>
          <button
            className="btn-danger"
            style={{ width: "100px" }}
            onClick={() => {
              if (isNew) {
                addNoteInformation();
              } else {
                updateNoteInformation();
              }
            }}
          >
            저장
          </button>
        </div>
      </div>
    </div>
  );
};
export default SalesNoteDetail;
